<ng-container *transloco="let t;">
    <div class="container d-flex justify-content-center align-items-center">
        <div class="w-100 py-4" style="max-width: 30rem;">
            <breadcrumb [items]='[{ label: t("header.frontpage"), route: "/"}, { label: t("header.testlogin")} ]'>
            </breadcrumb>
            <div class="content-box">
                <h4 class="card-title" *ngIf="testloginOption == testloginOptions.doctor">{{
                    t("login.titledoctor") }}
                </h4>
                <h4 class="card-title" *ngIf="testloginOption == testloginOptions.patient">{{
                    t("login.titlepatient") }}
                </h4>
                <form [formGroup]="testloginForm" (ngSubmit)="onSubmit()">
                    <div class="mb-3">
                        <label *ngIf="testloginOption == testloginOptions.doctor" for="user" class="form-label">{{
                            t("login.usernamedoctor") }}</label>
                        <label *ngIf="testloginOption == testloginOptions.patient" for="user" class="form-label">{{
                            t("login.usernamepatient") }}</label>
                        <input type="text" class="form-control" id="user" formControlName="user" autocomplete="off">
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label">{{ t("login.password") }}</label>
                        <input type="password" id="password" class="form-control" formControlName="password"
                            autocomplete="off">
                    </div>
                    <div class="mb-3 w-25" *ngIf="testloginOption == testloginOptions.doctor">
                        <label for="initials" class="form-label">{{ t("login.initials") }}</label>
                        <input type="text" id="initials" class="form-control" maxlength="10" formControlName="initials"
                            autocomplete="off">
                    </div>
                    <div class="col-auto text-end">
                        <button class="btn wp-btn d-inline-flex text-end">
                            <span class=" me-1">{{ t("login.buttonlabel") }}</span>
                            <svg class="icon-dark-bg icon-md">
                                <use xlink:href="assets/icons.svg#icon-login"></use>
                            </svg>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-container>

<div class="modal fade" id="testloginModal" tabindex="-1" aria-labelledby="testloginModal" data-bs-backdrop="static"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-body text-center">
                <ng-container *transloco="let t; prefix: 'login'">
                    <ng-container *ngIf="loginIsError; else isLoading">
                        <h3 class="modal-title fs-2">{{ t("errorheader") }}</h3>
                        <p class="text-muted">{{ t("errortext") }}</p>
                        <button class="btn wp-btn mx-auto" role="button" data-bs-dismiss="modal">{{ t("tryagainbutton")
                            }}</button>
                    </ng-container>
                    <ng-template #isLoading>
                        <loading-spinner-grow></loading-spinner-grow>
                        <p>{{ t("loadingtext") }}</p>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</div>